import { useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import type { ReturnRequestDto } from "../generated/schema";

interface UseAssignUserToReturnProps {
  onSuccess: (returnRequest: ReturnRequestDto) => void;
  onError?: (error: Error) => void;
}

export default function useAssignUserToReturn({
  onSuccess,
  onError,
}: UseAssignUserToReturnProps) {
  const errorNotification = useFormErrorNotification();

  return $api.useMutation("post", "/shops/{shopId}/return-requests/{returnRequestId}/assigned-users", {
    onSuccess(returnRequest) {
      onSuccess(returnRequest);
    },
    onError(error) {
      errorNotification();
      onError?.(error as Error);
    },
  });
}
